import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { bounties, bountyLevels } from "@/mocks/bounties";

export default function BountyPreview() {
  const topBounties = bounties.slice(0, 5);

  return (
    <section className="w-full bg-background-100 py-16 md:py-24" aria-labelledby="bounty-preview">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <SectionHeading
              id="bounty-preview"
              eyebrow="悬赏榜"
              title="悬赏线索排行，等你认领"
              description="每条悬赏都标明金额、等级与截止日期。线索被采纳后，将按约定等级发放悬赏并持续同步进展。"
            />
            <Link
              to="/bounty"
              className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              查看完整榜单
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <ul className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {topBounties.map((item, index) => (
                <li
                  key={item.rank}
                  className={`flex flex-wrap items-center gap-x-4 gap-y-2 px-4 py-4 transition-colors hover:bg-accent-50 md:px-6 ${
                    index !== topBounties.length - 1 ? "border-b border-background-200" : ""
                  }`}
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                      item.rank <= 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="truncate font-heading text-sm font-bold text-foreground-950 md:text-base">
                      <Link to="/bounty" title={`${item.title} - 悬赏线索`}>
                        {item.title}
                      </Link>
                    </h3>
                    <p className="mt-1 flex flex-wrap items-center gap-x-3 text-xs text-foreground-500">
                      <span>{item.category}</span>
                      <span>截止 {item.deadline}</span>
                      <span>{item.joiners} 人参与</span>
                    </p>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="rounded-md bg-secondary-100 px-2 py-1 text-xs font-medium text-secondary-800">
                      {item.level}
                    </span>
                    <span className="font-heading text-base font-bold text-accent-700">
                      ¥{item.amount.toLocaleString()}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">
                悬赏等级说明
              </h3>
              <ul className="mt-4 flex flex-col gap-4">
                {bountyLevels.map((level) => (
                  <li key={level.level} className="flex gap-3">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                      <i className={`${level.icon} text-lg`} />
                    </span>
                    <div>
                      <p className="flex items-center gap-2 text-sm font-bold text-foreground-900">
                        {level.level}
                        <span className="text-xs font-normal text-foreground-500">{level.range}</span>
                      </p>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-600">{level.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <Link
              to="/submit"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-hand-coin-line" />
              提供线索领悬赏
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}